export class Categoria {
  id: number;
  descricao: string;
  ativo: number;
  origens: CategoriaOrigem[];
  origensTexto: string;
  icone: string;
  ordem: number;

  // virtuais
  visivel: boolean;
}

export class CategoriaOrigem {
  id: number;
  idCategoria: number;
  idOrigem: number;
}
